import { Channel } from 'stream-chat'

type ChannelLike = Pick<Channel, 'type'> & { state: Pick<Channel['state'], 'members'> }

export const getDirectMessageTitle = (channel: ChannelLike, currentUserId?: string): string | undefined => {
    if (channel.type !== 'messaging') {
        return undefined
    }

    const otherMember = Object.values(channel.state.members)
        .find(member => member.user?.id !== currentUserId)

    return otherMember?.user?.name || undefined
}
